module.exports = __webpack_public_path__ + "img/logo.4039e9c5.png";